<template>
  <div>
    <div class="no_result particles_box" v-if="carList.length == 0">
      <img src="../assets/images/icon_4.png" />
      <p>购物车还是空的哦~</p>
      <router-link to="/">继续逛</router-link>
    </div>
    <div class="car container yu_fc particles_box" v-if="carList.length != 0">
      <div class="top_title">
        <h3 class="title">
          <label :class="isSelectAll ? 'active' : ''">
            <i></i>
            <input type="checkBox" @click="selectProduct(isSelectAll)" :checked="isSelectAll"/>全选
          </label>
        </h3>
        <h3 class="title yu_tc w422">商品信息</h3>
        <h3 class="title yu_tc w190">单价</h3>
        <h3 class="title yu_tc w190">数量</h3>
        <h3 class="title yu_tr w100">小计</h3>
        <h3 class="title pl60">操作</h3>
      </div>
      <ul class="goods_list">
        <li v-for="(item,index) in carList" :key="index">
          <div class="checked yu_fl" :class="item.isSelect ? 'active' : ''">
            <label :for="'checked' + index"><i></i></label>
            <input type="checkBox" :id="'checked' + index" :checked="item.isSelect" @click="isSelect(item.isSelect,index)" />
            <!-- item.isSelect = !item.isSelect -->
          </div>
          <div class="infor yu_fl w450">
            <img @click="onGoodsDetail(item.productId,item.productName,item.productCategoryId)" :src="item.productPic" />
            <p @click="onGoodsDetail(item.productId,item.productName,item.productCategoryId)">{{item.productName}}</p>
            <span>{{item.productAttr}}</span>
          </div>
          <div class="price yu_fl yu_tc w190">
            <span>￥{{item.price}}</span>
            <del>￥{{item.originalPrice}}</del>
          </div>
          <div class="number yu_fl yu_tc w190">
            <div class="minus" :class="item.quantity <= 1 ? 'active' : ''" @click="item.quantity > 0 ? item.quantity-- : ''">-</div>
            <div class="num"><input type="text" @input="onInput(item.quantity,index,item.stock)" v-model="item.quantity"></div>
            <div class="add" :class="item.quantity >= 99 || item.quantity == 0 || item.quantity >= item.stock ? 'active' : ''" @click="item.quantity++">+</div>
            <!-- <strong>{{ item.quantity }}</strong> -->
            <!--  :disabled="disableds" -->
          </div>
          <div class="total yu_fl yu_tr w100">
            <span>￥{{item.price * item.quantity | money}}</span>
          </div>
          <div class="opera yu_fl pl60">
            <span @click="collecPro(item.productId,item.id)">移入收藏夹</span>
            <span @click="deletePro(item.id)">删除</span>
          </div>
        </li>
      </ul>
      <!-- 结算 -->
      <div class="set_ment">
        <h3 @click="onDeles">批量删除</h3>
        <p>商品合计：&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;￥{{getTotal.totalPrice | money}}</p>
        <span>应付总额&ensp;&ensp;&ensp;&ensp;<i>￥{{getTotal.totalPrice | money}}</i></span>
        <div class="btn_order" :class="ids == '' ? 'active' : ''" @click="goOrder">下单</div>
      </div>
    </div>
  </div>
</template>

<script>
import { cartList, cartDels } from "@/api/cart";
import { productCollectionAdd } from "@/api/product";
export default {
  name: "car",
  data() {
    return {
      carList: [],
      height: "", // 一屏高度
      ids: "" // 选中id
    };
  },
  created() {
    this.getCar();
  },
  methods: {
    async getCar() {
      let _this = this;
      const res = await cartList();
      console.log(res);
      if (res.code == 200) {
        this.carList = res.data;
        // this.$store.commit("modify", data.length)
        // localStorage.setItem("carNum", data.length)
        // let NewPage = "car" + "?time=" + new Date().getTime() / 500;
        // this.$router.push(NewPage);
        // this.$router.go(-1);
        // 为carList添加select（是否选中）字段，初始值为true
        this.carList.map(function(item) {
          _this.$set(item, "isSelect", true);
          _this.ids += item.id + ","
        });
      }
      console.log(this.ids)
    },
    // 单选
    isSelect(check,index){
      check ? (this.carList[index].isSelect = false) : (this.carList[index].isSelect = true)
      let _this = this;
      this.ids = "";
      this.carList.map(function(item) {
        if(item.isSelect){
          _this.ids += item.id + ","
        }
      });
      console.log(this.ids)
    },
    // 全选
    selectProduct(_isSelect) {
      //遍历carList，全部取反
      for (var i = 0, len = this.carList.length; i < len; i++) {
        this.carList[i].isSelect = !_isSelect;
      }
      let _this = this;
      this.ids = "";
      this.carList.map(function(item) {
        if(item.isSelect){
          _this.ids += item.id + ","
        }
      });
      console.log(_this.ids)
    },
    // 限制数量
    onInput(e,i,s){
      this.carList[i].quantity = e.replace(/[^\d]/g,'')
      if(this.carList[i].quantity <= 1){
        this.carList[i].quantity = 1
      }
      if(s >= 99 && this.carList[i].quantity >= 99){
        this.carList[i].quantity = 99
      }
      if(s <= 99 && this.carList[i].quantity >= 99){
        this.carList[i].quantity = s
      }
    },
    // 收藏
    async collecPro(proid,id){
      const res = await productCollectionAdd(proid)
      console.log(res);
      if (res.code == 200) {
        this.$layer.msg("移入移入收藏夹成功");
        this.deletePro(id)
        this.getCar()
      }
      // const res = await this.$http.post(`/product/collection/add?productId=${proid}`);
      // const {
      //   data: { code, data, message }
      // } = res;
      // console.log(res);
      // if (code == 200) {
      //   this.$layer.msg("移入移入收藏夹成功");
      //   this.deletePro(id)
      //   this.getCar()
      // }
    },
    // 删除商品
    async deletePro(id) {
      const res = await cartDels(id)
      console.log(res);
      if (res.code == 200) {
        this.getCar();
      }
      // const res = await this.$http.post(`/member/cartItem/delete?ids=${id}`);
      // const {
      //   data: { code, data, message }
      // } = res;
      // console.log(res);
      // if (code == 200) {
      //   this.getCar();
      // }
    },
    // 批量删除
    async onDeles(){
      const res = await cartDels(this.ids)
      console.log(res);
      if (res.code == 200) {
        this.getCar();
      }
      // const res = await this.$http.post(`/member/cartItem/delete?ids=${this.ids}`);
      // const {
      //   data: { code, data, message }
      // } = res;
      // console.log(res);
      // if (code == 200) {
      //   this.getCar();
      // }
    },
    // 下单
    goOrder(){
      let _this = this;
      if(_this.ids != ""){
        _this.ids = "";
        _this.carList.map(function(item) {
          if(item.isSelect){
            _this.ids += item.id + ","
          }
        });
        _this.$router.push({
          path: "/order",
          query: {
            carId: _this.ids
          }
        })
      }
    },
    // 商品详情
    onGoodsDetail(id, name, proId){
      this.$router.push({
        path: "/goodsDetail",
        query: {
          id: id
        }
      })
      let classId = proId + ""
      localStorage.setItem("classId", classId.substring(0, 2))
    }
  },
  computed: {
    //检测是否全选
    isSelectAll() {
      //如果carList中每一条数据的isSelect都为true，返回true，否则返回false;
      return this.carList.every(function(val) {
        return val.isSelect;
      });
    },
    getTotal() {
      var prolist = this.carList.filter(function(val) {
          return val.isSelect;
        }),
        totalPri = 0;
      for (var i = 0, len = prolist.length; i < len; i++) {
        totalPri += prolist[i].price * prolist[i].quantity;
      }
      return { totalNum: prolist.length, totalPrice: totalPri };
    }
  },
  mounted() {
    // console.log(document.documentElement.clientHeight)
    // this.height = document.documentElement.clientHeight - 173 - 27 - 600
  }
};
</script>

<style scoped>
.car .top_title {
  color: #999;
  height: 48px;
  margin: 30px 0 21px;
  background: rgba(245, 245, 245, 1);
  border: solid 1px rgba(218, 218, 218, 1);
}
.car .top_title .title {
  float: left;
  line-height: 46px;
}
.car .top_title .title label{
  float: left;
  line-height: 46px;
}
.car .top_title .title label i{
   margin: 13px 23px;
}
.car .w100{
  width: 100px;
}
.car .w190{
  width: 190px;
}
.car .w422{
  width: 422px;
}
.car .w450{
  width: 450px;
}
.car .pl60{
  padding-left: 60px;
}
.car .goods_list {
  width: 100%;
  overflow: hidden;
}
.car .goods_list li {
  float: left;
  width: 100%;
  height: 154px;
  padding: 22px 0;
  margin-bottom: 12px;
  border: solid 1px #dadada;
  background: #fff;
}
.goods_list li .checked{
  margin: 45px 23px;
}
.car .goods_list li .infor img {
  float: left;
  width: 110px;
  height: 110px;
  margin-right: 22px;
  cursor: pointer;
}
.car .goods_list li .infor p {
  display: block;
  color: #333;
  font-size: 16px;
  line-height: 24px;
  padding-top: 5px;
  cursor: pointer;
}
.car .goods_list li .infor span {
  display: block;
  color: #999;
  line-height: 24px;
}
.car .goods_list li .price {
  font-size: 0;
  padding-top: 14px;
}
.car .goods_list li .price span,
.car .goods_list li .price del {
  color: #333;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
}
.car .goods_list li .price del {
  color: #999;
  padding-left: 7px;
}
.car .goods_list li .number{
  padding: 5px 21px
}
.car .goods_list li .number div{
  float: left;
  width: 40px;
  height: 35px;
  line-height: 33px;
  text-align: center;
  border: solid 1px #e2e2e2;
  -webkit-user-select:none; 
  -moz-user-select:none; 
  -ms-user-select:none; 
  user-select:none;
}
.car .goods_list li .number div.minus,
.car .goods_list li .number div.add{
  color: #999;
  font-size: 20px;
  cursor: pointer;
}
.car .goods_list li .number div.minus.active,
.car .goods_list li .number div.add.active{
  color: #e2e2e2;
  cursor: not-allowed;
}
.car .goods_list li .number div.num{
  color: #666;
  width: 67px;
  border-left: none;
  border-right: none;
  overflow: hidden;
}
.car .goods_list li .number div.num input{
  float: left;
  color: #666;
  width: 100%;
  height: 33px;
  line-height: 33px;
  text-align: center;
  border: none;
  background: #fff;
}
.car .goods_list li .total{
  color: #BE4141;
  font-size: 16px;
  padding-top: 14px;
}
.car .goods_list li .opera{
  padding-top: 14px;
}
.car .goods_list li .opera span{
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
  display: block;
  cursor: pointer;
}
.car .top_title .title label i,
.goods_list li .checked i{
  float: left;
  width: 19px;
  height: 19px;
  cursor: pointer;
  background-image: url("../assets/images/icon_0.png");
  background-position: 0 -122px;
}
.car .top_title .title label.active i,
.goods_list li .checked.active i{
  background-position: -19px -122px;
}
/* 结算 */
.car .set_ment{
  width:1200px;
  height:76px;
  margin-bottom: 50px;
  padding-left: 23px;
  background:rgba(245,245,245,1);
  border:1px solid rgba(218,218,218,1);
  overflow: hidden;
}
.car .set_ment h3,
.car .set_ment p,
.car .set_ment span{
  float: left;
  color: #333;
  font-size: 16px;
  line-height: 74px;
}
.car .set_ment h3{
  cursor: pointer;
}
.car .set_ment p{
  color: #999;
  padding-left: 400px;
  padding-right: 100px;
}
.car .set_ment span i{
  color: #BE4141;
  font-size: 24px;
  font-style: normal;
}
.car .set_ment .btn_order{
  float: right;
  color: #fff;
  font-size: 20px;
  width:154px;
  height: 74px;
  line-height: 74px;
  text-align: center;
  background:rgba(180,160,120,1);
  cursor: pointer;
}
.car .set_ment .btn_order.active{
  background: #ccc;
}
.no_result a {
  display: block;
  width: 110px;
  height: 44px;
  line-height: 42px;
  color: #B4A078;
  font-size: 20px;
  margin: 0 auto;
  background: rgba(245, 243, 239, 1);
  border: 1px solid rgba(180, 160, 120, 1);
  border-radius: 2px;
}
</style>